import dynamic from "next/dynamic";

export const DynamicContent059 = dynamic(() => import("./Content059"), {
  suspense: true,
});
